var TestsArchive = function(){

    'use strict';

    var $ = jQuery;
    var instances = [];


    function onReady() {
        $('.module.tests-archive').each(function () {
            instances.push(initInstance($(this)));
        });
    }

    function initInstance(view) {

        // Private properties
        // * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * 

        var $view = view,
            id = $view.data('id'),
            $owl = null;


        // Private methods
        // * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * 

        function initOwl() {
            $owl = $view.find('.owl-carousel').owlCarousel({
                // itemsCustom: [700,1],
                slideBy: 1,
                items: 3,
                // scrollPerPage: 1,
                slideSpeed: 1000,
                pagination: true,
                // startPosition: setCurrentTest(),
                // loop: true,
                // nav: true,
                // center: true,
                navText: [
                    '<i class="icon icon-angle-left"></i>',
                    '<i class="icon icon-angle-right"></i>',
                ],
                dots: true,
                // autoplay: true,
                // autoplayTimeout: 1000,
                responsiveClass: true,
                responsive : {
                    // breakpoint from 0 up
                    0 : {
                        items : 1,
                        slideBy: 1
                    },
                    // breakpoint from 480 up
                    660 : {
                        items : 2,
                        slideBy: 2
                    },
                    // breakpoint from 768 up
                    1024 : {
                        items: 3,
                        slideBy: 1
                    }
                },
                onInitialized: function () {
                    $view.find('a.test-link').css({
                        'display': 'block'
                    });
                    setTimeout(function () {
                        setCurrentTest(); 
                    });
                }
            });
        }

        function setCurrentTest() {
            var position = 0;
            var found = false;
            $view.find('.owl-item').each(function () {
                if ($(this).find('.test-link.selected').length === 0 && found === false) {
                    position++;
                }
                else {
                    found = true;
                }
            });

            $view.find('.owl-carousel').trigger('to.owl.carousel', position);
            // return position;
        }

        // instance object
        var instance = {
            init: function () {
                initOwl();
            }
        };

        instance.init();
        return instance;
    }

    // DOMContentLoaded
    $(onReady);

}

TestsArchive();
